@if (dot) {
  <span
    class="indicator-dot"
    [ngClass]="{ 'indicator-dot--active': isActive }"
    [title]="isActive ? 'Active' : 'Inactive'"></span>
} @else {
  <div class="indicator" [ngClass]="{ 'indicator--active': isActive }">
    <span class="indicator__swatch"></span>
    {{ isActive ? 'Active' : 'Inactive' }}
  </div>
}
